// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"eade5942","787":"ac33489c"}[chunkId] + ".chunk.js";
};